import { useExperimentFlag } from './useExperimentFlag';

export const useExperimentCheckoutOrderEdit = (): boolean => useExperimentFlag('enable_checkout_order_edit', 'exp');
